/**
 * UI del carrito: totales, descuentos y filas de items.
 */

function deriveCknNames(win, item) {
	if (item.cknNames && item.cknNames.length > 0) return;
	if (!item.ckn || !item.ckn.groups) return;
	const groups = win.posknCknCache && win.posknCknCache[item.originalId];
	if (!groups || !groups.length) return;
	const derived = [];
	Object.entries(item.ckn.groups).forEach(([gIndex, val]) => {
		const g = groups[parseInt(gIndex, 10)];
		if (!g || !Array.isArray(g.options)) return;
		const matchOpt = (idSel) =>
			g.options.find(
				(o) =>
					o != null &&
					(o.type === 'recipe'
						? String(o.recipe_id) === String(idSel)
						: String(o.id) === String(idSel))
			);
		const optLabel = (opt, idSel) => {
			if (!opt) return '';
			return opt.type === 'recipe' ? opt.label || opt.name || String(idSel) : opt.name || '';
		};
		if (val != null && typeof val === 'object' && !Array.isArray(val)) {
			Object.entries(val).forEach(([idSel, qty]) => {
				const opt = matchOpt(idSel);
				const nm = optLabel(opt, idSel);
				if (nm) derived.push(nm + (qty > 1 ? ` x${qty}` : ''));
			});
		} else {
			const selected = Array.isArray(val) ? val : [val];
			selected.forEach((idSel) => {
				const opt = matchOpt(idSel);
				const nm = optLabel(opt, idSel);
				if (nm) derived.push(nm);
			});
		}
	});
	if (derived.length) item.cknNames = derived;
}

export function attachCartUiGlobals(win, $) {
	win.calcularDescuento = function calcularDescuento(subtotal) {
		const descuentoActual = win.descuentoActual || { activo: false, tipo: 'porcentaje', valor: 0 };
		const round = typeof win.roundMoney === 'function' ? win.roundMoney : (n) => Math.round(Number(n) * 100) / 100;
		const toCents = typeof win.moneyToCents === 'function' ? win.moneyToCents : (n) => Math.round(Number(n) * 100);
		const fromCents = typeof win.moneyFromCents === 'function' ? win.moneyFromCents : (c) => (Number(c) || 0) / 100;
		if (!descuentoActual.activo) return 0;
		if (descuentoActual.tipo === 'porcentaje') {
			const pct = Math.min(100, Math.max(0, parseFloat(descuentoActual.valor) || 0));
			return fromCents(Math.round(toCents(subtotal) * (pct / 100)));
		}
		return round(Math.min(descuentoActual.valor, subtotal));
	};

	win.actualizarBadgesDescuento = function actualizarBadgesDescuento() {
		const descuentoActual = win.descuentoActual || { activo: false, tipo: 'porcentaje', valor: 0 };
		if (descuentoActual.activo) {
			const tipoTexto =
				descuentoActual.tipo === 'porcentaje'
					? `${descuentoActual.valor}%`
					: `$${descuentoActual.valor.toFixed(2)}`;
			$('#descuento-badge').text(tipoTexto).show();
			$('#descuento-activo-compacto').show().find('.descuento-detalle-compacto').text(tipoTexto);
		} else {
			$('#descuento-badge').hide();
			$('#descuento-activo-compacto').hide();
		}
	};

	win.actualizarEstadoCarrito = function actualizarEstadoCarrito() {
		const carrito = win.carrito || [];
		const totalProductos = carrito.reduce((sum, item) => sum + item.cantidad, 0);
		const tot =
			typeof win.posknTotalesDesdeCarrito === 'function'
				? win.posknTotalesDesdeCarrito()
				: { totalUsd: carrito.reduce((sum, item) => sum + item.price * item.cantidad, 0) };
		const totalUsd = tot.totalUsd;

		$('#productos-contador').text(totalProductos);
		$('#btn-pagar').prop('disabled', totalUsd <= 0);

		if (typeof win.updateCartToggleButton === 'function') win.updateCartToggleButton();
		win.actualizarBadgesDescuento();
	};

	win.actualizarCarrito = function actualizarCarrito() {
		const carrito = win.carrito || [];
		const tbody = $('#carrito-items');
		tbody.empty();

		if (win.mesaSeleccionada) {
			$('#mesa-indicador-carrito').show();
			$('#mesa-numero-carrito').text(win.mesaSeleccionada.numero);
		} else {
			$('#mesa-indicador-carrito').hide();
		}

		if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();

		let subtotalUsd = 0;
		let subtotalBsDirect = 0;
		const precioFn =
			typeof win.posknPrecioUnitarioCarrito === 'function'
				? win.posknPrecioUnitarioCarrito
				: (item) => ({ usd: parseFloat(item.price) || 0, bs: (parseFloat(item.price) || 0) * (win.TASA_DOLAR || 1) });
		const lineTotal =
			typeof win.moneyLineTotal === 'function'
				? win.moneyLineTotal
				: (price, qty) => Number(price) * Number(qty);

		carrito.forEach((item, index) => {
			const esCocina = !!item.enCocina;
			deriveCknNames(win, item);
			const unitPrices = precioFn(item);
			item.price = unitPrices.usd;
			const totalItem = lineTotal(unitPrices.usd, item.cantidad);
			const totalItemBs = lineTotal(unitPrices.bs, item.cantidad);
			subtotalUsd += totalItem;
			subtotalBsDirect += totalItemBs;

			const badgeCocina = esCocina ? '<span class="badge-en-cocina">En cocina</span>' : '';
			const cantidadHtml = `<input type="number" class="cantidad-input" value="${item.cantidad}" min="0.01" step="0.01" onchange="cambiarCantidad(${index}, this.value)">`;
			const botonEliminar = `<button class="btn-eliminar" onclick="eliminarDelCarrito(${index})">&times;</button>`;

			const row = $(`
				<tr>
					<td style="max-width: 80px; overflow: hidden; text-overflow: ellipsis;">
						${item.name} ${badgeCocina}
						${item.cknNames && item.cknNames.length > 0 ? `<br><small style="color:#2e7d32;">${item.cknNames.map((name) => `• ${name}`).join('<br>')}</small>` : ''}
						${item.notas ? `<br><small style="color: #666;">${item.notas}</small>` : ''}
					</td>
					<td>${cantidadHtml}</td>
					<td style="text-align: right;">
						<div style="font-weight: bold; color: #2196F3;">$${totalItem.toFixed(2)}</div>
						${win.POSKN_MULTIMONEDA ? `<div style="font-size: 11px; color: #4CAF50;">Bs. ${totalItemBs.toFixed(2)}</div>` : ''}
					</td>
					<td>${botonEliminar}</td>
				</tr>
			`);
			tbody.append(row);
		});

		const totCart =
			typeof win.posknTotalesDesdeCarrito === 'function' ? win.posknTotalesDesdeCarrito() : null;
		const descuentoUsd = totCart ? totCart.descuentoUsd : win.calcularDescuento(subtotalUsd);
		const deliveryUsd = totCart
			? totCart.deliveryUsd
			: typeof win.getDeliveryFeeUsd === 'function'
				? win.getDeliveryFeeUsd()
				: 0;
		const totalUsd = totCart ? totCart.totalUsd : subtotalUsd - descuentoUsd + deliveryUsd;
		const subtotalBs = totCart ? totCart.subtotalBs : subtotalBsDirect;
		const descuentoBs = totCart
			? totCart.descuentoBs
			: subtotalBsDirect - subtotalBsDirect * (subtotalUsd > 0 ? (subtotalUsd - descuentoUsd) / subtotalUsd : 1);
		const deliveryBs = totCart ? totCart.deliveryBs : deliveryUsd * (win.TASA_DOLAR || 1);
		const totalBs = totCart ? totCart.totalBs : subtotalBsDirect - descuentoBs + deliveryBs;
		subtotalUsd = totCart ? totCart.subtotalUsd : subtotalUsd;

		$('#subtotal-usd').text(`$${subtotalUsd.toFixed(2)}`);
		$('#subtotal-bs').text(`Bs. ${subtotalBs.toFixed(2)}`);

		const descuentoActual = win.descuentoActual || { activo: false };
		if (descuentoActual.activo && descuentoUsd > 0) {
			$('#descuento-row-usd').show().find('.descuento-amount-usd').text(`-$${descuentoUsd.toFixed(2)}`);
			$('#descuento-row-bs').show().find('.descuento-amount-bs').text(`-Bs. ${descuentoBs.toFixed(2)}`);
		} else {
			$('#descuento-row-usd, #descuento-row-bs').hide();
		}

		if (deliveryUsd > 0) {
			$('#delivery-row-usd').show().find('.delivery-amount-usd').text(`+$${deliveryUsd.toFixed(2)}`);
			$('#delivery-row-bs').show().find('.delivery-amount-bs').text(`+Bs. ${deliveryBs.toFixed(2)}`);
		} else {
			$('#delivery-row-usd, #delivery-row-bs').hide();
		}

		$('#total-usd').text(`$${totalUsd.toFixed(2)}`);
		$('#total-bs').text(`Bs. ${totalBs.toFixed(2)}`);

		win.actualizarEstadoCarrito();
		if (typeof win.checkCarritoScroll === 'function') win.checkCarritoScroll();
		if (typeof win.guardarBorradorPedido === 'function') {
			win.guardarBorradorPedido();
		}
	};

	win.eliminarDelCarrito = function eliminarDelCarrito(index) {
		const carrito = win.carrito || (win.carrito = []);
		const quitar = () => {
			carrito.splice(index, 1);
			win.actualizarCarrito();
			win.mostrarNotificacion('Producto eliminado', 'success');
		};
		if (win.posknCodigoLimpiar && String(win.posknCodigoLimpiar).trim().length > 0) {
			win.posknPedirCodigo('Código para eliminar producto').then((codigo) => {
				if (codigo === false) return;
				quitar();
			});
			return;
		}
		quitar();
	};

	win.cambiarCantidad = function cambiarCantidad(index, nuevaCantidad) {
		const carrito = win.carrito || (win.carrito = []);
		nuevaCantidad = parseFloat(nuevaCantidad);
		if (nuevaCantidad <= 0) {
			win.eliminarDelCarrito(index);
			return;
		}
		if (nuevaCantidad > 999.99) {
			win.mostrarNotificacion('La cantidad no puede ser mayor a 999.99', 'error');
			win.actualizarCarrito();
			return;
		}
		const item = carrito[index];
		if (item) {
			// Compuesto sin descuento de padre: no limitar por stock del producto padre.
			const skipParentStock =
				!!item.is_composite_kn && !item.composite_deduct_parent;
			if (!skipParentStock) {
				const baseId = item.stockBaseId || item.originalId || item.id;
				const varId = item.stockVariationId || item.variacionId || 0;
				const managing =
					item.stockManaging != null
						? !!item.stockManaging
						: typeof win.posknResolveManagingStock === 'function'
							? win.posknResolveManagingStock(win.posknFindProductoEnData(baseId), varId)
							: false;
				const stockDisponible = win.posknGetStockDisponible(baseId, varId, item.stockFallback, managing);
				const yaEnCarrito = win.posknCantidadEnCarrito(baseId, varId, index);
				if (
					stockDisponible !== null &&
					yaEnCarrito + nuevaCantidad > parseFloat(stockDisponible) + 0.0001
				) {
					win.mostrarNotificacion(
						`Stock insuficiente. Disponible: ${parseFloat(stockDisponible).toFixed(2)}`,
						'error'
					);
					win.actualizarCarrito();
					return;
				}
			}
		}
		carrito[index].cantidad = nuevaCantidad;
		win.actualizarCarrito();
	};
}
